import PropTypes from 'prop-types'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import LanguageSwitcher from '../common/LanguageSwitcher'

function Menu({ showLanguageSwitcher }) {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)
  const location = useLocation()

  const toggleMenu = () => setIsOpen(!isOpen)

  const handleShopClick = () => {
    window.alert(t('shopComingSoon'))
  }

  const isActive = (path) => {
    if (path === '/' && location.pathname === '/') return true
    if (path !== '/' && location.pathname.startsWith(path)) return true
    return false
  }
  Menu.propTypes = {
    showLanguageSwitcher: PropTypes.bool,
  }
  return (
    <>
      <div className={`side_menu4_overlay${isOpen ? ' show' : ''}`}></div>
      <div className={`side_menu_style4${isOpen ? ' show' : ''}`}>
        <div className="content">
          <div className="main_links">
            <ul>
              <li>
                <a href="/" className={`main_link marcellus ${isActive('/') ? 'active' : ''}`}>
                  {t('home')}
                </a>
              </li>
              <li>
                <a
                  href="/about"
                  className={`main_link marcellus ${isActive('/about') ? 'active' : ''}`}
                >
                  {t('nav.about')}
                </a>
              </li>
              <li>
                <a
                  href="/gallery"
                  className={`main_link marcellus ${isActive('/gallery') ? 'active' : ''}`}
                >
                  {t('nav.gallery')}
                </a>
              </li>
              <li>
                <a
                  href="/custom"
                  className={`main_link marcellus ${isActive('/custom') ? 'active' : ''}`}
                >
                  {t('custom')}
                </a>
              </li>
              <li>
                <a
                  href="/contact"
                  className={`main_link marcellus ${isActive('/contact') ? 'active' : ''}`}
                >
                  {t('nav.contact')}
                </a>
              </li>
              <li>
                <button
                  onClick={handleShopClick}
                  className="main_link marcellus"
                  style={{
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    cursor: 'pointer',
                    color: '#fff',
                  }}
                >
                  {t('shop')}
                </button>
              </li>
            </ul>

            {showLanguageSwitcher && (
              <div className="mobile_lang_switch mt-4">
                <LanguageSwitcher isMobile={true} />
              </div>
            )}
          </div>
        </div>

        <span
          className="clss"
          onClick={toggleMenu}
          role="button"
          aria-label="Close menu"
          tabIndex={0}
        >
          <svg width="26" height="26" viewBox="0 0 24 24" aria-hidden="true">
            <path
              d="M6 6l12 12M18 6l-12 12"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        </span>
      </div>

      <button className="side_menu_btn" onClick={toggleMenu} aria-label="Open menu" type="button">
        <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
          <path
            d="M3 6h18M3 12h18M3 18h18"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      </button>
    </>
  )
}

export default Menu
